var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('head-bar'),_c('side-bar'),_c('div',{staticClass:"content-box"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(this.$store.state.loading),expression:"this.$store.state.loading"}],staticClass:"content"},[_c('router-view'),_c('el-backtop',{attrs:{"target":".content"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }